import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'
import { cn } from '@/lib/cn'

/**
 * Botón del sistema (§2): principal negro en píldora, secundario blanco con
 * borde, y un "sutil" para acciones dentro de tarjetas. Área táctil de 44 px.
 */
const boton = cva(
  [
    'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full',
    'text-sm font-medium transition-colors select-none',
    'min-h-11 px-5',
    'disabled:pointer-events-none disabled:opacity-40',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-tinta',
  ],
  {
    variants: {
      variante: {
        principal: 'bg-tinta text-white hover:bg-tinta/90',
        secundario: 'border border-borde bg-tarjeta text-tinta hover:bg-lienzo',
        sutil: 'bg-transparent text-tinta hover:bg-lienzo',
        peligro: 'bg-transparent text-nuevo hover:bg-nuevo/10',
      },
      tamano: {
        normal: 'min-h-11 px-5',
        chico: 'min-h-9 px-4 text-[13px]',
        icono: 'min-h-11 min-w-11 px-0',
      },
    },
    defaultVariants: {
      variante: 'principal',
      tamano: 'normal',
    },
  },
)

type BotonProps = ComponentProps<'button'> &
  VariantProps<typeof boton> & {
    /** Renderiza el hijo (por ejemplo un `<a>`) con los estilos del botón. */
    asChild?: boolean
  }

export function Boton({
  className,
  variante,
  tamano,
  asChild = false,
  ...props
}: BotonProps) {
  const Comp = asChild ? Slot : 'button'
  return (
    <Comp
      data-slot="boton"
      className={cn(boton({ variante, tamano }), className)}
      {...(asChild ? {} : { type: props.type ?? 'button' })}
      {...props}
    />
  )
}
